import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLoaderComponent {
  @Input() active = false;
}
